class AgentConfigService {
  constructor(httpDim, config) {
    this.httpDim = httpDim;
    this.config = config;
  }

  getAgentConfig(){
    let url = this.config.apiRoot + '/agentConfigs';
    return this.httpDim.get(url, {
      transformResponse: this.transformAgentConfigTimeResponse
    });
  }

  updateAgentConfig(agentConfig){
    let url = this.config.apiRoot + '/agentConfigs';
    return this.httpDim.put(url, agentConfig, {
      transformRequest: this.transformAgentConfigTimeRequest
    });
  }

  toggleAutoSync(agentConfig) {
    let url = this.config.apiRoot + '/agentConfigs';
    return this.httpDim.put(url, agentConfig);
  }

  transformAgentConfigTimeResponse(response) {
    let parsedResponse = JSON.parse(response);
    parsedResponse.content.time = `January 1, 1980 ${parsedResponse.content.time}`;
    return parsedResponse;
  }

  transformAgentConfigTimeRequest(request) {
    if (!request.time.getHours) {
      request.time = new Date(request.time);
    }
    request.time = `${request.time.getHours()}:${request.time.getMinutes()}:00`;
    let stringifiedRequest = JSON.stringify(request);
    return stringifiedRequest;
  }
}

AgentConfigService.$inject = ['httpDim', 'config'];

export default AgentConfigService;



// WEBPACK FOOTER //
// ./app/components/syncSchedule/agentConfig.service.js